import { render, staticRenderFns } from "./RefsThg.vue?vue&type=template&id=7538854e&scoped=true&"
import script from "./RefsThg.vue?vue&type=script&lang=ts&"
export * from "./RefsThg.vue?vue&type=script&lang=ts&"
import style0 from "./RefsThg.vue?vue&type=style&index=0&id=7538854e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7538854e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAvatar,VChip,VIcon,VListItem,VListItemContent,VListItemSubtitle})
